import ColorPicker from "components/basic/color-picker/ColorPicker";
import { DatasetDropdown } from "components/basic/dropdowns/dataset/DatasetDropdown";
import { InputNumber } from "primereact/inputnumber";
import React from "react";
import { T } from "services/lang/LanguageService";
import { SparkLineInputsProps } from "../sparkline/SparkLineInputs";

type SparkLineAdvancedInputsProps = SparkLineInputsProps;

const SparkLineAdvancedInputs: React.FC<SparkLineAdvancedInputsProps> = ({ 
  currentConfig,
  onDatasetChange,
  onConfigChange,
 }) => {
  
  return (
    <div className="grid col-12 border-1 border-gray-200 border-round p-3 ml-2">
    <div className="col-12 mb-3">
      <label htmlFor="baselineDataset">{T("label.baseline-dataset")}</label>
      <DatasetDropdown
        value={currentConfig.baselineDataset}
        onChange={val => onDatasetChange("baselineDataset", val)}
      />
    </div>
    <div className="w-5 md:w-3 mb-3">
      <label htmlFor="baselineWidth">{T("label.baseline-width")}</label>
      <InputNumber
        id="baselineWidth"
        value={currentConfig.baselineWidth}
        onValueChange={onConfigChange}
        useGrouping={false}
        suffix=" px"
        className="p-inputtext-sm"
      />
    </div>
    <div className="w-5 md:w-3 mb-3">
      <label htmlFor="baselineColor">{T("label.baseline-color")}</label>
      <ColorPicker
        id="baselineColor"
        value={currentConfig.baselineColor}
        onValueChange={onConfigChange}
      />
    </div>
    <div className="w-5 md:w-3 mb-3">
      <label htmlFor="fillAboveColor">{T("label.above-fill-color")}</label>
      <ColorPicker
        id="fillAboveColor"
        value={currentConfig.fillAboveColor}
        onValueChange={onConfigChange}
      />
    </div>
    <div className="w-5 md:w-3 mb-3">
      <label htmlFor="fillBelowColor">{T("label.below-fill-color")}</label>
      <ColorPicker
        id="fillBelowColor"
        value={currentConfig.fillBelowColor}
        onValueChange={onConfigChange}
      />
    </div>
  </div>
  )
}

export default SparkLineAdvancedInputs;